import React, { forwardRef, useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { cn } from '../../utils/cn';
import { useFormField } from '../FormField/FormField';

export const NumberInput = forwardRef(function NumberInput(
  { value, defaultValue = 0, onChange, min, max, step = 1, size = 'md', isDisabled, className, ...rest },
  ref
) {
  const field = useFormField();
  const [internal, setInternal] = useState(defaultValue);
  const v = value !== undefined ? value : internal;

  const set = (next) => {
    if (min !== undefined && next < min) return;
    if (max !== undefined && next > max) return;
    setInternal(next);
    onChange?.(next);
  };

  const sizeCls = { sm: 'h-8 text-sm', md: 'h-10 text-sm', lg: 'h-11 text-base' }[size];
  const btnCls = { sm: 'w-7', md: 'w-9', lg: 'w-10' }[size];

  return (
    <div className={cn('inline-flex items-stretch border border-border rounded-md bg-surface overflow-hidden', sizeCls, isDisabled && 'opacity-50 pointer-events-none', className)}>
      <button type="button" aria-label="Décrémenter" onClick={() => set(v - step)} className={cn('flex items-center justify-center text-mute hover:bg-bg-2 hover:text-text border-r border-border', btnCls)}>
        <Minus className="w-3.5 h-3.5" strokeWidth={2} />
      </button>
      <input
        ref={ref}
        id={field?.id}
        type="number"
        value={v}
        min={min} max={max} step={step}
        onChange={(e) => set(Number(e.target.value))}
        className="flex-1 min-w-0 text-center bg-transparent outline-none px-1 font-mono tabular-nums"
        aria-describedby={field?.describedBy}
        {...rest}
      />
      <button type="button" aria-label="Incrémenter" onClick={() => set(v + step)} className={cn('flex items-center justify-center text-mute hover:bg-bg-2 hover:text-text border-l border-border', btnCls)}>
        <Plus className="w-3.5 h-3.5" strokeWidth={2} />
      </button>
    </div>
  );
});

export default NumberInput;
